export const DATETIME_FORMAT_ISO = "YYYY-MM-DDTHH:mm:ss[Z]";
export const DATETIME_ISO = "YYYY-MM-DDTHH:mm:ss.SSSZ";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_UK = "MM DD YYYY";
export const TIME_FORMAT = "HH:mm";
export const TIME_FORMAT_ISO = "HH:mm:ss";
export const HUMAN_DATE_FORMAT = "Do MMM YY";
export const UIDateFormat = "DD-MM-YYYY";
export const UITimeFormat = "HH:mm";
export const ComplianceAPIDateFormat = "YYYY-MM-DD";
export const ComplianceUIDateTimeFormat = "YYYY-MM-DD HH:mm";
